import { UseCaseRequest, updateUsecasePost } from '@cecm-microservices-sdk/core/services/apigateway/update-usecase';
import { getMicroservicesClient } from '@/services/microservices/client';
import type { MicroservicesCountryCode } from './usedCarEligibility';

export async function updateUseCase(
    countryCode: MicroservicesCountryCode,
    payload: UseCaseRequest,
) {
    const client = getMicroservicesClient(countryCode);

    if (!client.baseUrl) {
        throw new Error(
            `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
        );
    }

    return updateUsecasePost(client, payload);
}
